@let tabs = tabs2();
<p-tabs [(value)]="value" (valueChange)="onChange($event)">
  <p-tablist class="flex-shrink-0">
    @for (t of tabs; track $index) {
      <p-tab [class]="t.tabClass" [value]="t.value" [disabled]="t.disabled">
        {{ t.header }}
        @if (t.closable) {
          <span class="fas fa-times ml-2" (click)="close(t.value, $event)" style="cursor:pointer"></span>
        }
      </p-tab>
    }
  </p-tablist>
  <p-tabpanels>
    @for (t of tabs; track $index) {
      <p-tabpanel [value]="t.value">
        <ng-container [ngTemplateOutlet]="t.contentTpl"></ng-container>
      </p-tabpanel>
    }
  </p-tabpanels>
</p-tabs>
